import { Avatar, Box, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { setSelectedItem } from 'app/actions/user';
import { Autosizer, Image, Scrollbar } from 'app/components';
import { sessionSelector } from 'app/selectors/session';
import { selectedItemUserSelector, sortItemsUserSelector } from 'app/selectors/user';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const UserList = () => {
    const dispatch = useDispatch();
    const session = useSelector(sessionSelector);
    const selectedItem = useSelector(selectedItemUserSelector);
    const sortItems = useSelector(sortItemsUserSelector);
    const handleItemClick = (value) => {
        dispatch(setSelectedItem(value));
    };
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '.MuiChip-root': {
                    padding: theme.spacing(0),
                    lineHeight: '14px',
                    transition: 'none',
                },
                '.MuiListItemAvatar-root': {
                    minWidth: '36px',
                },
                '.MuiAvatar-circular': {
                    width: '24px',
                    height: '24px',
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    borderRadius: '0',
                },
                '.MuiListItemText-root': {
                    margin: theme.spacing(0),
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 36, overscanCount: 10, itemCount: sortItems.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: userListInnerElementType, itemData: {
                    items: sortItems,
                    yourId: session.id,
                    selectedItem,
                    onClick: handleItemClick,
                } }, userListItemRender))))))));
};
const userListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
const userListItemRender = ({ data, index, style }) => {
    const { items, yourId, selectedItem, onClick } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: item.id, style: style, selected: item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), onClick: () => onClick(item), secondaryAction: item.id === yourId && React.createElement(Chip, { label: '\u0412\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442', size: 'small', color: 'primary' }), sx: (theme) => (Object.assign(Object.assign({}, (!item.active && {
            opacity: '0.5',
        })), ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id && {
            '.MuiChip-root': {
                color: theme.palette.primary.main,
                bgcolor: theme.palette.primary.contrastText,
            },
        }))) },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, null,
                    React.createElement(Image, { name: `avatar-${item.role_id}.png`, alt: `avatar-${item.role_id}` }))),
            React.createElement(ListItemText, { primary: item.name }))));
};
export default UserList;
